import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { LayoutService } from '../../services/layout.service';
import { JwtAuthService } from '../../services/auth/jwt-auth.service';
import { LanguageService, Language } from '../../services/language.service';
import { Utils } from '../../../utils/utils';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AppInfoService } from '../../services/app-info.service';
import { AboutDialogComponent } from '../about-dialog/about-dialog.component';

@Component({
  selector: 'app-header-side',
  templateUrl: './header-side.template.html',
  styleUrls: ['./header-side.component.scss']
})
export class HeaderSideComponent implements OnInit, OnDestroy {
  @Input() notificPanel;
  public availableLangs: Language[];
  public currentLang: Language;
  utils = Utils;
  public egretThemes;
  public layoutConf: any;
  private langSub: Subscription;

  constructor(
    private themeService: ThemeService,
    private layout: LayoutService,
    public jwtAuth: JwtAuthService,
    private languageService: LanguageService,
    public appInfo: AppInfoService,
    private dialog: MatDialog
  ) {}

  openAbout() {
    this.dialog.open(AboutDialogComponent, { autoFocus: false });
  }

  ngOnInit() {
    this.egretThemes = this.themeService.egretThemes;
    this.layoutConf = this.layout.layoutConf;
    this.availableLangs = this.languageService.getAvailableLangs();

    this.langSub = this.languageService.currentLang$.subscribe((lang: Language) => {
      this.currentLang = lang;
    });
  }

  ngOnDestroy() {
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
  }

  setLang(lng: Language) {
    this.languageService.setLang(lng);
  }

  toggleNotificationPanel() {
    if (this.notificPanel) {
      this.notificPanel.toggle();
    }
  }

  toggleSidenav() {
    this.layout.publishLayoutChange({
      sidebarStyle: this.layoutConf.sidebarStyle === 'closed' ? 'full' : 'closed'
    });
  }

  openExternalApp(url: string) {
    window.open(url, '_blank');
  }

  get empresaNomeSessao(): string {
    const item = this.jwtAuth.item$?.value;
    const filial = this.jwtAuth.filial$?.value;
    return item?.empresaRemota?.nomeFantasia
      || filial?.nomeFantasia
      || filial?.razaoSocial
      || '';
  }
}
